export default __webpack_public_path__ + "static/media/chopping-vegetables.101f5314.mp3";